var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2080_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.292C0 1.026 1.08487 0 2.42344 0H30.5766C31.9151 0 33 1.026 33 2.292V29.708C33 30.974 31.9151 32 30.5766 32H2.42344C1.08487 32 0 30.974 0 29.708V2.292ZM10.1949 26.788V12.338H5.24288V26.788H10.1949ZM7.71994 10.364C9.44625 10.364 10.5208 9.256 10.5208 7.868C10.4899 6.45 9.44831 5.372 7.75294 5.372C6.05756 5.372 4.95 6.452 4.95 7.868C4.95 9.256 6.02456 10.364 7.68694 10.364H7.71994ZM17.8427 26.788V18.718C17.8427 18.286 17.8757 17.854 18.0077 17.546C18.3645 16.684 19.1792 15.79 20.5487 15.79C22.341 15.79 23.0567 17.114 23.0567 19.058V26.788H28.0087V18.5C28.0087 14.06 25.5667 11.996 22.308 11.996C19.6804 11.996 18.5027 13.396 17.8427 14.382V14.432H17.8097L17.8427 14.382V12.338H12.8927C12.9546 13.694 12.8927 26.788 12.8927 26.788H17.8427Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2080_174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.db9b3d6cd664f64fbcceadb94cfb0f35.svg";
export { ForwardRef as ReactComponent };